import React, { useEffect, useState } from "react";
import { Button, TextField, MenuItem } from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";

export default function StoreDomains() {
  const [data, setData] = useState(null);
  const [kind, setKind] = useState("custom");
  const [hostname, setHostname] = useState("");
  const [busy, setBusy] = useState(false);
  const [check, setCheck] = useState(null);
  useEffect(() => {
    let mounted = true;
    api.get("/negocio/storefront/domains").then(({ data: result }) => {
      if (!mounted) return;
      setData(result);
      if (result.canManageSubdomains && result.baseDomain) setKind("subdomain");
    }).catch(toastError);
    return () => { mounted = false; };
  }, []);
  useEffect(() => {
    setCheck(null);
    if (kind !== "subdomain" || !hostname.trim()) return undefined;
    let mounted = true;
    const timer = setTimeout(() => {
      api.get("/negocio/storefront/domains/availability", { params: { kind, hostname } })
        .then(({ data: result }) => { if (mounted) setCheck(result); })
        .catch(error => { if (mounted) setCheck({ available: false, reason: error.response?.data?.error || "No se pudo comprobar el nombre." }); });
    }, 450);
    return () => { mounted = false; clearTimeout(timer); };
  }, [kind, hostname]);
  const run = async action => {
    setBusy(true);
    try { const result = await action(); setData(result.data); } catch (err) { toastError(err); } finally { setBusy(false); }
  };
  const existing = data?.records?.find(row => row.kind === kind);
  const target = data?.dnsCnameTarget || "la dirección de esta plataforma";
  const address = data?.dnsAddress || "";
  const proposed = kind === "subdomain" ? `${hostname.trim().toLowerCase()}.${data?.baseDomain || ""}` : hostname.trim().toLowerCase();
  const save = () => {
    if (existing && existing.hostname !== proposed && !window.confirm(`Vas a cambiar ${existing.hostname} por ${proposed}. La dirección anterior dejará de abrir la tienda y seguirá reservada para tu empresa. ¿Continuar?`)) return;
    return run(() => api.put("/negocio/storefront/domains", { kind, hostname }));
  };
  return <section style={{ display: "grid", gap: 12 }}>
    <h3>Dirección de tu tienda</h3>
    {data?.canManageSubdomains && <TextField id="store-domain-kind" select label="Tipo de dirección" variant="outlined" value={kind} onChange={e => { setKind(e.target.value); setHostname(""); }}>
      <MenuItem value="subdomain">Subdominio de la tienda</MenuItem>
      <MenuItem value="custom">Dominio propio</MenuItem>
    </TextField>}
    {kind === "subdomain" ? <>
      <p>Elige un nombre disponible. Tu tienda tendrá su propia dirección con HTTPS.</p>
      {!data?.wildcardReady && <p role="status">Puedes reservar tu nombre. La dirección se activará automáticamente cuando finalice la configuración inicial de DNS y HTTPS de la plataforma. Mientras tanto usa el enlace actual de tu tienda.</p>}
      <TextField id="store-subdomain-name" label="Nombre del subdominio" variant="outlined" value={hostname} onChange={e => setHostname(e.target.value)} inputProps={{ maxLength: 63 }} helperText={`Tu dirección será nombre.${data?.baseDomain || ""}. Usa entre 3 y 63 letras, números o guiones.`} />
      {hostname.trim() && <div><strong>https://{proposed}</strong><p role="status">{check ? check.available ? "Nombre disponible" : check.reason : "Comprobando disponibilidad…"}</p></div>}
    </> : <>
      <p>Tu tienda ya funciona con su enlace. Para usar un dominio propio, sigue estos pasos.</p>
      <ol>
        <li>Escribe el dominio completo y guarda la dirección, sin https:// ni rutas.</li>
        <li>En el DNS crea <strong>un solo registro</strong>: para un subdominio, un CNAME hacia <strong>{target}</strong>; para el dominio raíz, un registro A hacia <strong>{address || "la IP de la plataforma"}</strong>.</li>
        <li>Pulsa <strong>Comprobar</strong>. El acceso HTTPS de dominios externos lo activa la plataforma.</li>
      </ol>
      <TextField label="Dominio (ejemplo: tienda.miempresa.com)" variant="outlined" value={hostname} onChange={e => setHostname(e.target.value)} helperText="Escribe solamente el dominio, sin https:// ni rutas." />
    </>}
    <div className="store-actions"><Button disabled={busy || !data || !hostname.trim() || (kind === "subdomain" && !check?.available)} variant="outlined" onClick={save}>
      {kind === "subdomain" ? data?.wildcardReady ? "Guardar y activar" : "Reservar subdominio" : "Guardar dirección"}
    </Button></div>
    {data?.records?.map(row => <div key={row.hostname} style={{ border: "1px solid #ddd", borderRadius: 8, padding: 14, overflowWrap: "anywhere" }}>
      <strong>{row.hostname}</strong>
      <p>{row.active ? "Activo · HTTPS" : row.kind === "subdomain" ? "Reservado · activación automática pendiente" : row.verified ? "Verificado · pendiente de activar HTTPS" : "Pendiente de comprobar"}</p>
      <div className="store-actions">
        {row.active && <Button component="a" href={`https://${row.hostname}`} target="_blank" rel="noopener noreferrer">Abrir tienda</Button>}
        {row.kind === "custom" && !row.verified && <Button disabled={busy} onClick={() => run(() => api.post("/negocio/storefront/domains/verify", { hostname: row.hostname }))}>Comprobar</Button>}
        <Button disabled={busy} onClick={() => {
          if (window.confirm(`¿Quitar ${row.hostname}? Dejará de abrir la tienda. El nombre seguirá reservado para tu empresa.`)) run(() => api.delete("/negocio/storefront/domains", { data: { hostname: row.hostname } }));
        }}>Quitar dirección</Button>
      </div>
    </div>)}
  </section>;
}
